import { SvgBase } from "../svg.base";

export const ArrowDownNoTail = () => (
  <SvgBase width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons-/-Arrow-/-Down" fill="currentColor" fillRule="nonzero">
          <polygon id="Path" points="7.41 8.59 12 13.17 16.59 8.59 18 10 12 16 6 10"></polygon>
        </g>
      </g>
    </g>
  </SvgBase>
);